import PermissionGate from '@/components/Permissions/PermissionGate';
import DrivePage from '@/modules/drive/DrivePage';
import type { RouteObject } from 'react-router-dom';

const driveRouteElement = (
  <PermissionGate requiredPermissions="oru-drive-access">
    <DrivePage />
  </PermissionGate>
);

export const routes: RouteObject[] = [
  {
    path: 'drive',
    handle: {
      breadcrumbKey: 'menu.drive',
    },
    element: driveRouteElement,
  },
  {
    path: 'drive/:folderId',
    handle: {
      breadcrumbKey: 'menu.drive',
    },
    element: driveRouteElement,
  },
];
